import { FC } from 'react';

import { useCoworkingMinPriceSelector } from 'shared/hooks/selectors/coworking/useCoworkingMinPriceSelector';

import { InfoMinPrice } from './internal/components/InfoMinPrice';

import * as styles from './NoneSelectedOfferHeader.css';

export const NoneSelectedOfferHeader: FC = () => {
  const minPrice = useCoworkingMinPriceSelector();

  if (!minPrice) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <InfoMinPrice minPrice={minPrice} />
    </div>
  );
};

NoneSelectedOfferHeader.displayName = 'NoneSelectedOfferHeader';
